var _circle, _animate, _animateTransform, _animate2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    opacity: 0.1,
    stroke: "#000000",
    strokeWidth: 3,
    cx: 25,
    cy: 25,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,25) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#48B0F7",
      fill: "none",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    strokeDasharray: 110,
    strokeDashoffset: 0,
    cx: 0,
    cy: 0,
    r: 20
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "360;140",
    dur: "2.2s",
    keyTimes: "0;1",
    calcMode: "spline",
    fill: "freeze",
    keySplines: "0.41,0.314,0.8,0.54",
    repeatCount: "indefinite",
    begin: 0
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0;274;360",
    keyTimes: "0;0.74;1",
    calcMode: "linear",
    dur: "2.2s",
    repeatCount: "indefinite",
    begin: 0
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#10CFBD;#48B0F7;#6D5CAE;#48B0F7;#10CFBD",
    fill: "freeze",
    dur: "8s",
    begin: 0,
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.de34e31b1738c0f5b5700dfcbe9a7355.svg";
export { ForwardRef as ReactComponent };